import { Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { DesktopHeaderComponent } from 'src/app/general-components/desktop-header/desktop-header.component';
import { UserFormComponent } from "../../general-components/user-form/user-form.component";

@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
  standalone: true,
  imports: [
    IonicModule,
    DesktopHeaderComponent,
    UserFormComponent
]
})
export class ProfilePage {}
